import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts';

function Chart({ categorie, serie }) {

  const barCategory = ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct']
  const [BarChartData, setBarChartData] = useState({

    series: serie
    // [{
    //     name: '_200',
    //     data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
    //   }, {
    //     name: '_406',
    //     data: [76, 85, 101, 98, 87, 105, 91, 114, 94]
    //   }, {
    //     name: '_409',
    //     data: [76, 80, 95, 88, 77, 85, 81, 104, 74]
    //   }, {
    //     name: '_422',
    //     data: [35, 41, 36, 26, 45, 48, 52, 53, 41]
    //   }]
    ,
    options: {
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: barCategory,
      },
      yaxis: {
        title: {
          text: 'Hits'
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + " Hits"
          }
        }
      }
    },
  });

  useEffect(() => {
    setBarChartData(prevState => ({
      ...prevState,
      options: {
        ...prevState.options,
        xaxis: {
          ...prevState.options.xaxis,
          categories: categorie,
        },
      },
    }));

  }, [categorie])


  return (
    <>
      <ReactApexChart options={BarChartData.options} series={serie} type="bar" height={350} />
    </>
  )
}
export default Chart